import { render, staticRenderFns } from "./authCode.vue?vue&type=template&id=65cde12c&scoped=true&"
import script from "./authCode.vue?vue&type=script&lang=js&"
export * from "./authCode.vue?vue&type=script&lang=js&"
import style0 from "./authCode.vue?vue&type=style&index=0&id=65cde12c&lang=scss&scoped=true&"
import style1 from "./authCode.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cde12c",
  null
  
)

export default component.exports